// import { ParallaxLayer } from '@react-spring/parallax';

import ContentRowCmp from '#src/components/ContentRow/index.js';

export function ContentRow(props) {
  return <ContentRowCmp {...props} />;
}
